import React from 'react';
import { Button, Header, Icon, Modal } from 'semantic-ui-react';

export default class Purchaser extends React.Component {

  state = {open: false}

  render() {
    let { item } = this.props;
    return (
      <div>
        <p onClick={() => this.setState({open: true})}>
          {item.purchaser_name + " " + item.purchaser_mobile}
        </p>
        <Modal open={this.state.open} basic size='small'>
          <Header content={item.purchaser_name} />
          <Modal.Content>
            <h3>
              <br />
              Mobile: {item.purchaser_mobile}
              <br /><br />
              Address: {item.purchaser_address}
              <br /><br />
              GSTIN: {item.purchaser_gstin}
              <br /><br />
            </h3>
          </Modal.Content>
          <Modal.Actions>
            <Button color='green' inverted onClick={() => this.setState({open: false})}>
              <Icon name='checkmark' /> OK
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }

}
